export const clientVertical = [
  {
    label: "Clientele Sweet Spot",
    content: (
      <ul className="list-disc">
        <li>
          <b>SMBs and mid-market organisations:</b> Ready to embrace AWS for
          measurable digital transformation and fast access to new tools and
          journey innovations.
        </li>
        <li>
          <b>Large enterprises and government:</b> With complex, high-volume,
          multi-location operations, demanding data privacy, automation,
          resilience, and rapid peak scaling.
        </li>
        <li>
          <b>Businesses encumbered by legacy platforms and vendor lock-in:</b>{" "}
          Seeking a risk-mitigated fast path to the agility and cost benefits of
          a cloud-native AWS foundation.
        </li>
        <li>
          <b>CX innovators and early adopters:</b> Hungry to push boundaries
          with next-generation AI, omnichannel, analytics, and predictive
          customer engagement.
        </li>
        <li>
          <b>
            Organisations with pressing integration, workflow automation, or
            data governance requirements:
          </b>{" "}
          Where a disjointed legacy stack limits agility and strategic insights.
        </li>
      </ul>
    ),
  },
  {
    label: "Verticals & iCXeed Fit",
    content: (
      <div>
        <p>
          iCXeed's operational models, custom toolkits, and industry frameworks
          are built to address the unique regulatory, integration, and scale
          requirements found in:
        </p>

        <ul>
          <li>
            <strong>Financial Services | </strong> Intelligent customer
            servicing, regulatory compliance, digital channel orchestration.
          </li>
          <li>
            <strong>eCommerce and Retail | </strong> Customer journey
            orchestration, demand forecasting, omnichannel engagement.
          </li>
          <li>
            <strong>Digital Media & Entertainment |</strong> Content
            personalisation, audience analytics, rights management.
          </li>
          <li>
            <strong>Manufacturing / Wholesale / Distribution</strong> — B2B
            sales and post-sales automation, supply chain optimisation.
          </li>
          <li>
            <strong>Healthcare |</strong> Secure member engagement, compliance,
            CX-centred workflows.
          </li>
          <li>
            <strong>Travel & Hospitality |</strong> Guest journey
            digitalisation, loyalty-driven engagement, operational efficiency.
          </li>
          <li>
            <strong>Education |</strong> Student support, digital campus.
          </li>
        </ul>
      </div>
    ),
  },
  {
    label: "Client Pain Points Addressed",
    content: (
      <ul>
        <li>
          <b>High operational costs and/or inefficiency:</b> Challenges in
          maintaining cost-effective, efficient contact centre operations.
        </li>
        <li>
          <b>Inconsistent customer experience:</b> Across channels (voice, chat,
          email, SMS, social) and languages.
        </li>
        <li>
          <b>Manual, error-prone QA and compliance:</b> Leading to risk exposure
          and inconsistent quality.
        </li>
        <li>
          <b>Limited self-service and automation:</b> Causing high human agent
          workload and dependency.
        </li>
        <li>
          <b>Difficulty integrating disparate systems:</b> Such as CRM, ERP, HR,
          and security platforms.
        </li>
        <li>
          <b>Lack of real-time analytics and insights:</b> Limited visibility
          into operations and missed opportunities for optimisation.
        </li>
        <li>
          <b>Challenges in scaling support:</b> During peak periods or business
          growth phases.
        </li>
        <li>
          <b>Slow innovation cycles:</b> Inability to quickly trial and adopt
          new AWS features.
        </li>
        <li>
          <b>Barriers to migration:</b> Difficulty moving from legacy platforms
          to AWS-native environments.
        </li>
      </ul>
    ),
  },
  {
    label: "How We Win",
    content: (
      <ul className="list-disc pl-5 space-y-3">
        <li>
          <b>Rapid results:</b> Launch new AWS-native CX and automation projects
          in as little as two weeks — no waiting, we move as quickly as our
          clients require us to.
        </li>
        <li>
          <b>Embedded expertise:</b> Founders with 65+ years’ cross-industry
          success guide every engagement, solving real problems and tackling
          complex integrations hands-on.
        </li>
        <li>
          <b>Managed for growth:</b> 24/7 support and proactive optimisation
          keep systems in top shape, freeing account managers to focus on
          driving new opportunities.
        </li>
        <li>
          <b>Innovation first:</b> We pilot new AI and AWS features faster,
          ensuring clients stay ahead in performance, compliance, and
          capability.
        </li>
        <li>
          <b>Commercial flexibility:</b> Pay-as-you-go, no lock-in, phased
          rollouts and pilots — designed to remove barriers and close AWS deals
          faster.
        </li>
        <li>
          <b>Deep partnership:</b> We engage early, co-design tailored roadmaps,
          and embed change management — empowering clients and strengthening AWS
          collaboration.
        </li>
        <li>
          <b>Extra mile, every time:</b> Whether it's custom reporting, advanced
          analytics, or supporting expansion into new channels, we deliver more
          than promised.
        </li>
      </ul>
    ),
  },
];
